import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { referenceImagesSelector } from 'apps/formsCreationKit/store/selectors/referenceImages'
import {
  imageSizeChoices,
  AdvancedSettingsPanel,
  LimitedAdvancedSettings,
} from 'apps/studio/components/settings/fields/Base/advanced'
import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const DrawingReferenceImageSelect = {
  label: 'Reference Image',
  settingType: 'selectInput',
  property: 'reference_data_id',
  dynamicChoices: ({ label: entryLabel }) => {
    const referenceImages = useSelector(referenceImagesSelector) || []
    const options = useMemo(() => {
      return [
        {
          value: '',
          label: 'None',
          additionalProperties: {
            label: entryLabel,
            createOrUpdateRefDataEntry: true,
          },
        },
      ].concat(
        referenceImages
          .map(({ id, name }) => ({
            value: id,
            label: name,
            additionalProperties: {
              label: entryLabel,
              createOrUpdateRefDataEntry: true,
            },
          }))
          .sort((a, b) => a.label.localeCompare(b.label))
      )
    }, [referenceImages])

    return options
  },
}

export const DrawingSize = {
  label: 'Drawing Size',
  settingType: 'selectInput',
  property: 'style',
  choices: imageSizeChoices,
}

export const AdvancedPanel = AdvancedSettingsPanel([
  SettingsLabel('Config'),
  DrawingReferenceImageSelect,
  DrawingSize,
  ...LimitedAdvancedSettings,
])
